import ScrollRow from "./ScrollRow";

export default ScrollRow;
